import { supabase } from '../lib/supabaseClient';
import type { CapacityParameterRecord } from '../components/ops/capacityParameters';

interface CapacityParameterRow {
  id: string;
  organization_id: string;
  department_id: string | null;
  available_fte: number | null;
  productivity_tasks_per_person_hour: number | null;
  valid_from: string;
  valid_to: string | null;
  active: boolean;
}

function mapRow(row: CapacityParameterRow): CapacityParameterRecord {
  return {
    id: row.id,
    organizationId: row.organization_id,
    departmentId: row.department_id,
    availableFte: row.available_fte == null ? null : Number(row.available_fte),
    productivityTasksPerPersonHour: row.productivity_tasks_per_person_hour == null
      ? null
      : Number(row.productivity_tasks_per_person_hour),
    validFrom: row.valid_from,
    validTo: row.valid_to,
    active: row.active,
  };
}

const COLUMNS = 'id, organization_id, department_id, available_fte, productivity_tasks_per_person_hour, valid_from, valid_to, active';

export async function listCapacityParameters(organizationId: string): Promise<CapacityParameterRecord[]> {
  const { data, error } = await supabase
    .from('capacity_parameter')
    .select(COLUMNS)
    .eq('organization_id', organizationId)
    .order('valid_from', { ascending: false });
  if (error) throw error;
  return (data ?? []).map((row) => mapRow(row as CapacityParameterRow));
}

export async function createCapacityParameter(input: {
  organizationId: string;
  departmentId: string | null;
  availableFte: number | null;
  productivityTasksPerPersonHour: number | null;
  validFrom: string;
  validTo: string | null;
}): Promise<void> {
  const { data: auth } = await supabase.auth.getUser();
  const { error } = await supabase.from('capacity_parameter').insert({
    organization_id: input.organizationId,
    department_id: input.departmentId,
    available_fte: input.availableFte,
    productivity_tasks_per_person_hour: input.productivityTasksPerPersonHour,
    valid_from: input.validFrom,
    valid_to: input.validTo,
    active: true,
    created_by: auth.user?.id ?? null,
  });
  if (error) throw error;
}

export async function deactivateCapacityParameter(id: string): Promise<void> {
  const { error } = await supabase
    .from('capacity_parameter')
    .update({ active: false, updated_at: new Date().toISOString() })
    .eq('id', id);
  if (error) throw error;
}
